import type { TaskResourceItemProps } from "@wayflyer/flyui";
import type { IntlShape } from "react-intl";
import type { KYCAirSchema } from "shared-ui";

import { getAirItemLabel } from "./get-air-text";

type TaskResourceItemPropsWithId = TaskResourceItemProps & { id: string };

export const getAirResourceItems = (
  intl: IntlShape,
  airs: KYCAirSchema[],
  goToAirScreen: (airId: string) => void
): TaskResourceItemPropsWithId[] => {
  const airResourceItems = ((): TaskResourceItemPropsWithId[] => {
    return airs.map((air) => {
      if (air.status === "waiting_on_customer") {
        return {
          id: air.ref_id,
          testId: air.public_id,
          label: getAirItemLabel(intl, air.ref_id, air.question_type, air.question_parameters, true),
          action: {
            type: "button",
            onClick: () => goToAirScreen(air.public_id),
            label: intl.formatMessage({
              id: "KYC Air: View",
              defaultMessage: "View",
            }),
          },
          status: undefined,
          statusText: undefined,
        };
      } else {
        return {
          id: air.ref_id,
          label: getAirItemLabel(intl, air.ref_id, air.question_type, air.question_parameters, true),
          status: "positive",
          statusText: intl.formatMessage({
            id: "KYC Air: Completed",
            defaultMessage: "Completed",
          }),
        };
      }
    });
  })();

  // Sort by status first: "in_progress" (undefined for resource item) comes before other statuses
  // If statuses are the same, sort by id, which is the ref_id
  const sortedAirsItems = airResourceItems.sort((a, b) => {
    if (a.status === undefined && b.status !== undefined) {
      return -1;
    }
    if (a.status !== undefined && b.status === undefined) {
      return 1;
    }
    return a.id.localeCompare(b.id);
  });

  return sortedAirsItems;
};
